import { useStore } from "@/context/StoreContext";
import { Reveal } from "@/components/Reveal";
import { Testimonials } from "@/components/Testimonials";
import { Button } from "@/components/ui/button";
import { Check, Download, Lock, ShieldCheck } from "lucide-react";

export default function Bundle() {
  const { bundle, openCheckout } = useStore();
  if (!bundle) return <div className="mx-auto max-w-7xl px-5 py-32 text-muted-foreground">Loading…</div>;
  const save = (bundle.compare_at_price - bundle.price).toFixed(0);

  return (
    <div data-testid="bundle-page">
      <section className="mx-auto max-w-7xl px-5 pt-16 lg:px-8 lg:pt-24">
        <div className="relative grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <Reveal>
            <div className="relative overflow-hidden border border-black/10">
              <div className="absolute left-4 top-4 z-10 bg-white px-3 py-1 text-[10px] uppercase tracking-[0.2em]">Best Value</div>
              <img src={bundle.mockup_image} alt={bundle.title} className="aspect-[4/5] w-full object-cover grayscale" />
            </div>
          </Reveal>
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">The Complete Blueprint Bundle</p>
            <h1 className="mt-4 font-display text-5xl font-extrabold leading-[0.95] tracking-tighter sm:text-6xl">Get everything.<br />Save over 35%.</h1>
            <p className="mt-6 max-w-md text-muted-foreground">{bundle.description}</p>
            <ul className="mt-8 grid grid-cols-2 gap-3">
              {bundle.whats_included?.map((g) => <li key={g} className="flex items-center gap-2 text-sm"><Check className="h-4 w-4" /> {g}</li>)}
            </ul>
            <div className="mt-8 flex items-end gap-3">
              <span className="font-display text-5xl">${bundle.price?.toFixed(2)}</span>
              <span className="mb-1 text-xl text-muted-foreground line-through">${bundle.compare_at_price?.toFixed(2)}</span>
              <span className="mb-1.5 bg-primary px-2 py-0.5 text-[11px] font-medium text-primary-foreground" data-testid="bundle-savings-badge">Save ${save}</span>
            </div>
            <Button data-testid="bundle-get-everything" onClick={() => openCheckout({ item_type: "bundle", slug: "complete-bundle", title: bundle.title, price: bundle.price })}
              className="mt-8 w-full rounded-none h-14 bg-primary text-primary-foreground hover:bg-primary/90 sm:w-auto sm:px-12">
              <Lock className="h-4 w-4" /> Get Everything
            </Button>
            <div className="mt-5 flex flex-wrap gap-5 text-xs text-muted-foreground">
              <span className="inline-flex items-center gap-1.5"><Download className="h-3.5 w-3.5" /> Instant Download</span>
              <span className="inline-flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5" /> Secure Stripe Checkout</span>
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8">
        <div className="grid grid-cols-1 gap-12 border-t border-black/10 pt-16 md:grid-cols-2">
          <div>
            <h2 className="font-display text-2xl tracking-tight">Who it's for</h2>
            <ul className="mt-5 space-y-3">
              {bundle.who_its_for?.map((w) => <li key={w} className="flex gap-3 text-sm text-muted-foreground"><Check className="mt-0.5 h-4 w-4 text-foreground" /> {w}</li>)}
            </ul>
          </div>
          <div>
            <h2 className="font-display text-2xl tracking-tight">Why the bundle</h2>
            <ul className="mt-5 space-y-3">
              {bundle.benefits?.map((b) => <li key={b} className="flex gap-3 text-sm text-muted-foreground"><Check className="mt-0.5 h-4 w-4 text-foreground" /> {b}</li>)}
            </ul>
          </div>
        </div>
      </section>

      <Testimonials />
    </div>
  );
}
